import ReferencePayment from "../features/referencePayment/ReferencePayment";
import { fuelPaymentService } from "../features/referencePayment/referencePaymentServices";

const Fuel = () => <ReferencePayment service={fuelPaymentService} />;

export default Fuel;
